import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import i18n from '~/i18n'
import EmailValidator from '~/Classes/emailValidator'
import axios from '~/data/http/axios'

export default function Part1ProviderInstructions({ domainId, setFlowStep, domainProvider }) {
    const site = useSelector((state) => state.siteMaster)

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            setFlowStep('spfDkimSettings')
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown)
        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [])

    const kbUrl = domainProvider?.kbUrl
        ? domainProvider?.kbUrl
        : 'https://transpond.io/support/deliverability-and-compliance/authenticating-your-email-domain'

    return (
        <>
            <ol>
                {domainProvider?.instructions?.map((instruction, index) => {
                    return (
                        <li
                            key={index}
                            style={{ marginBottom: 10 }}
                            dangerouslySetInnerHTML={{
                                __html: instruction.replace(
                                    '{{loginHereLink}}',
                                    `<a href="${domainProvider.controlPanelUrl}" target="_blank">here</a>`
                                )
                            }}
                        />
                    )
                })}
            </ol>

            <Button
                text={i18n.t('company:domains.domainManagement.continue')}
                iconRight={<Icons icon='arrowRight' />}
                className='button-primary mar-t5'
                onClick={() => {
                    setFlowStep('spfDkimSettings')
                }}
            />

            {domainProvider.value != 'NONE' && (
                <div className='mar-t20 text-grey-800' style={{ fontSize: 13 }}>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: i18n.t('company:domains.domainManagement.providerStepsNote', {
                                supportEmailLink: `<a data-ph="authenticate_domain_dns_contact_support" href="mailto:${site.supportEmail}?subject=${domainProvider?.label + ' DNS Help'}">${i18n.t('company:domains.domainManagement.contactSupportTeam')}</a>`
                            })
                        }}
                    />

                    {site.siteId === 1 && (
                        <div className='mar-t10' style={{ display: 'flex', gap: 5 }}>
                            <span>{i18n.t('company:domains.domainManagement.guideTitle')}</span>
                            <a style={{ display: 'flex' }} href={kbUrl} target='_blank'>
                                {i18n.t('company:domains.domainManagement.providerArticle', {
                                    provider: domainProvider?.label
                                })}{' '}
                                <Icons icon='external' style={{ marginLeft: 3, height: 20 }} />
                            </a>
                            <span>{i18n.t('company:domains.domainManagement.providerMightHelp')}</span>
                        </div>
                    )}
                </div>
            )}

            {domainProvider.value == 'NONE' && (
                <div className='mar-t20 text-grey-800' style={{ fontSize: 13 }}>
                    {site.siteId === 1 && (
                        <div className='mar-b10'>
                            <span className='mar-r5'>{i18n.t('company:domains.domainManagement.providerGuide')}</span>
                            <a
                                href='https://transpond.io/support/deliverability-and-compliance/how-to-update-dns-settings-in-popular-providers'
                                target='_blank'
                            >
                                {i18n.t('company:domains.domainManagement.guideTitle')}
                            </a>
                        </div>
                    )}
                    <div
                        dangerouslySetInnerHTML={{
                            __html: i18n.t('company:domains.domainManagement.providerSupport', {
                                supportLink: `<a data-ph="authenticate_domain_dns_contact_support" href="mailto:${site.supportEmail}?subject=DNS Help">${i18n.t('company:domains.domainManagement.contactSupportTeam')}</a>`
                            })
                        }}
                    />
                </div>
            )}
        </>
    )
}
